var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-layout',{attrs:{"title":"Bienvenido de vuelta","subtitle":'Ingresa a tu cuenta de ' + _vm.commerce_name}},[_c('form-login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }